exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dup-selected-count[data-v-78fa29c8]{font-weight:600}.dup-action-link[data-v-78fa29c8],.dup-selected-count[data-v-78fa29c8]{font-size:13px;white-space:nowrap}", ""]);

// exports
